import { PosIconProps, SvgWrapper } from 'src/svgs/SvgWrapper';

export function ChevronLeftIconV3(props: PosIconProps) {
  return (
    <SvgWrapper
      aria-label="ChevronLeftIcon"
      fill="currentColor"
      {...props}
      viewBox="8 6 8 12"
      style={{ transform: 'scaleX(-1)' }}
    >
      <path
        d="M10.75 16.75L15.25 11.75L10.75 6.75"
        strokeLinecap="round"
        stroke="currentColor"
        fill="none"
      />
    </SvgWrapper>
  );
}
